import { lazy } from 'react';

// Types
import { GetGeoLocationProps as LazyComponentProps } from './GetGeoLocation.types';

// Components
import withSuspense, { lazyRetry } from '../suspense';

const LazyComponent = lazy(() => lazyRetry(() => import(/* webpackChunkName: "getGeoLocation" */ './GetGeoLocation')));

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'GetGeoLocation');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as GetGeoLocation };
